import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { mapGraphQLErrors } from 'providers/tanstack-query/utils'
import { Schema } from '../schema'
import { toDTO } from './api/mapper'
import { UPDATE_FINANCE_REPORT_URL } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpdateFinanceReportUrl } from './types'

export const useUpdateFinanceReportUrl = (): UseUpdateFinanceReportUrl => {
  const { t } = useTranslation('features/finance')
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_FINANCE_REPORT_URL,
    onCompleted: async (data: Data) => {
      const {
        updateWorkspace: { errors },
      } = data

      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('form.error.update'), {
          variant: 'error',
        })
      } else {
        setErrors({})
        enqueueSnackbar(t('form.success.update'), {
          variant: 'success',
        })
      }
    },
    queriesToInvalidate: ['getFinanceReportUrl'],
  })

  const update = (data: Schema): void => {
    void mutateAsync({
      input: toDTO(data),
    })
  }

  return {
    errors,
    loading: isPending,
    update,
  }
}
